import { ArrowBack } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import _ from "lodash";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import InsuranceInfo from "src/components/RegistrationComponents/InsuranceInfo";
import PaymentInfo from "src/components/RegistrationComponents/PaymentInfo";
import PersonalInfo from "src/components/RegistrationComponents/PersonalInfo";
import CompletedRegistration from "src/containers/FollowUpPage/CompletedRegistration";
import { useQuery } from "src/services/utils";

import PageTitle from "@components/PageTitle";

const STEPS = {
  INFO: "info",
  INSURANCE: "insurance",
  PAYMENT: "payment",
  COMPLETE: "complete",
};

const CompleteProfile = () => {
  const { INFO, INSURANCE, PAYMENT, COMPLETE } = STEPS;
  const history = useHistory();
  const query = useQuery();
  const step = _.values(STEPS).includes(query.get("step") || "") ? query.get("step") : INFO;

  const goToNextStep = () => {
    let nextStep = step;
    if (step === INFO) {
      nextStep = INSURANCE;
    } else if (step === INSURANCE) {
      nextStep = PAYMENT;
    } else if (step === PAYMENT) {
      nextStep = COMPLETE;
    }
    history.push(`/complete-profile?step=${nextStep}`);
  };

  return (
    <Box sx={{ padding: 1 }}>
      <PageTitle title="Complete Your Profile" backRoute="/patientDashboardPage" />
      {step === INFO && <PersonalInfo onContinue={goToNextStep} />}
      {step === INSURANCE && <InsuranceInfo onContinue={goToNextStep} />}
      {step === PAYMENT && <PaymentInfo onContinue={goToNextStep} />}
      {step === COMPLETE && <CompletedRegistration />}
    </Box>
  );
};

export default CompleteProfile;
